import * as signalR from "@microsoft/signalr";
import store from "./store";
import { showSessionTimeoutPopup } from "./session/sessionSlice";
import { API_BASE_URL, IMAGE_BASE_URL } from "./../Utills/config";
const key = "Customer-API-Token";
const BASE_URL = API_BASE_URL;

const method = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
};


async function fetchAPI(urlExtention, params = null, m = "GET") {
  const token = localStorage.getItem(key); // or your customer token key
  const refreshToken = localStorage.getItem("authRefreshToken");
  const url = BASE_URL + urlExtention;

  const fetchParams = {
    headers: {
      "Bypass-Tunnel-Reminder": "true",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    method: m,
  };

  if (params && m !== "GET") {
    fetchParams.body = JSON.stringify(params);
  }

  try {
    let response = await fetch(url, fetchParams);

    // Handle Token Expiry
    if (response.status === 401 && refreshToken) {
      console.log("Customer session expired, refreshing...");

      const userInfo = JSON.parse(localStorage.getItem("userInfo") || null);
      const restaurantId = userInfo?.restaurantId; // || 'FA6886A5-8CAA-4EDB-95BB-5E6EE8D95349';
      const tableNumber = userInfo?.tableNumber;
      const urlExtention = `AuthRefreshToken?restaurantId=${restaurantId}&tableNumber=${tableNumber}`;
      const refreshUrl = `AuthRefreshToken/${restaurantId}/${tableNumber}`;
      // Call the Customer specific refresh endpoint
      const refreshResponse = await fetch(BASE_URL + refreshUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ refreshToken: refreshToken }),
      });

      if (refreshResponse.ok) {
        const data = await refreshResponse.json();

        const payload = parseJwt(data.token);
        const expiryTime = payload.exp * 1000;
        localStorage.setItem("tokenExpiry", expiryTime.toString());

        // Store new tokens
        localStorage.setItem(key, data.token);
        localStorage.setItem("authRefreshToken", data.refreshToken);

        // Update header and retry
        fetchParams.headers["Authorization"] = `Bearer ${data.token}`;
        return await fetch(url, fetchParams);
      } else {
        // If refresh fails, the QR session is likely invalid/closed
        console.warn("Customer refresh failed. Redirecting to scan...");
        localStorage.clear();
        // You might want to redirect them back to the welcome/scan page
        //window.location.href = "/";
        store.dispatch(showSessionTimeoutPopup());
        return response;
      }
    }

    // Final check: if it's still 401 after refresh attempt
    if (response.status === 401) {
      store.dispatch(showSessionTimeoutPopup());
      // window.location.href = "/";
    }

    return response;
  } catch (error) {
    console.error("Customer API call failed:", error);
    throw error;
  }
}

function parseJwt(token) {
  try {
    const base64Payload = token.split(".")[1];
    const decoded = atob(base64Payload);
    return JSON.parse(decoded);
  } catch {
    return null;
  }
}

async function sendOtp(params, phoneNumber) {
  try {
    const url = `${BASE_URL}${params}`; // NO phone number in URL

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        phoneNumber: phoneNumber,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`failed to send otp: ${errorText}`);
    }

    const data = await response.json(); // { token: "..." }
    localStorage.setItem("login-otp", data.loginOtp);
    return data;
  } catch (error) {
    console.error("Error during sending otp:", error.message);
    throw error; // allow calling function to handle error
  }
}

async function fetchLogin(params, request) {
  console.log("Login request", request);
  const url = `${BASE_URL}${params}`; // NO phone number in URL

  const response = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      phoneNumber: request.phoneNumber,
      otp: request.otp,
      qRScan: request.qRScan,
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`failed to verify otp: ${errorText}`);
  }

  const data = await response.json(); // { token: "..." }

  if (data.isCustomerRegister !== 0) {
    // Decode JWT payload
    const payload = parseJwt(data.jwtToken);
    if (!payload) throw new Error("Invalid token payload");

    const { user, jwt, refreshToken } = {
      user: data.response,
      jwt: data.jwtToken,
      refreshToken: data.refreshToken,
    };

    const loggedInUser = {
      restaurantId: payload.restaurantOrBranchId,
      qRScanLogId: payload.qRScanLogId,
      tableId: payload.tableId,
      userName: payload.userName,
      name: payload.name,
      tableNumber: payload.tableNumber,
      customerId: payload.customerId,
      isUserAlreadyRegister: data.isCustomerRegister,
    };

    const expiryTime = payload.exp * 1000;
    console.log("loggedInUser fetchLogin", loggedInUser);
    localStorage.setItem(key, jwt);
    localStorage.setItem("authRefreshToken", refreshToken);
    localStorage.setItem("tokenExpiry", expiryTime.toString());
    //localStorage.setItem('userDetail', JSON.stringify(user));
    localStorage.setItem("userInfo", JSON.stringify(loggedInUser));
    console.log("KEY: ", localStorage.getItem(key));
    return user;
  } else {
    return null;
  }
}

async function registerUser(params, request) {
  console.log("registerUser request", request);
  const url = `${BASE_URL}${params}`; // NO phone number in URL

  const response = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      restaurantOrBranchId: request.restaurantId,
      tableNumber: request.tableNumber,
      tableOtp: request.tableOtp || "",
      customer: request.customer,
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`failed to verify otp: ${errorText}`);
  }

  const data = await response.json();

  if (data.isCustomerRegister !== 0) {
    // Decode JWT payload
    const payload = parseJwt(data.jwtToken);
    if (!payload) throw new Error("Invalid token payload");

    // const { user, jwt } = {user: data.response, jwt: data.jwtToken}
    const { user, jwt, refreshToken } = {
      user: data.response,
      jwt: data.jwtToken,
      refreshToken: data.refreshToken,
    };
    console.log("jwt payload", payload);
    const loggedInUser = {
      restaurantId: payload.restaurantOrBranchId,
      qRScanLogId: payload.qRScanLogId,
      tableId: payload.tableId,
      userName: payload.userName,
      name: payload.name,
      tableNumber: payload.tableNumber,
      customerId: payload.customerId,
      isUserAlreadyRegister: data.isCustomerRegister,
    };
    const expiryTime = payload.exp * 1000;
    console.log("loggedInUser fetchLogin", loggedInUser);
    localStorage.setItem(key, jwt);
    localStorage.setItem("authRefreshToken", refreshToken);
    localStorage.setItem("tokenExpiry", expiryTime.toString());
    //localStorage.setItem('userDetail', JSON.stringify(user));
    localStorage.setItem("userInfo", JSON.stringify(loggedInUser));
    console.log("KEY: ", localStorage);

    //  console.log("loggedInUser registerUser",loggedInUser)
    //  localStorage.setItem(key, jwt)
    //  localStorage.setItem('userInfo', JSON.stringify(loggedInUser));
    //  console.log('KEY: ', localStorage.getItem(key));
    return user;
  }
}

async function fetchRestaurantLoginConfigApi(restaurantId) {
  try {
    const url = `${BASE_URL}GetRestaurantLoginConfig/${restaurantId}`;
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`API error! Status: ${response.status}`);
    }

    // Plain string text parse karke return karega (jaise 'black-mode')
    return await response.json();
  } catch (error) {
    console.error("Error inside fetchRestaurantThemeApi:", error);
    throw error; // Error aage pass karein taaki router me catch ho sake
  }
}

async function apiPlaceOrder(params, orderList) {
  console.log("placeOrder request", orderList);

  const userInfo = JSON.parse(localStorage.getItem("userInfo") || null);
  const restaurantId = userInfo?.restaurantId; // || 'FA6886A5-8CAA-4EDB-95BB-5E6EE8D95349';
  const tableNumber = localStorage.getItem("table") || userInfo?.tableNumber;
  const customerId = userInfo?.customerId;
  console.log("customerId", customerId);
  console.log("userInfo", userInfo);
  const urlExtention = `${params}?restaurantId=${restaurantId}&customerId=${customerId}&tableNumber=${tableNumber}`;
  try {
      const response = await fetchAPI(urlExtention, orderList, method.POST);
      if (!response.ok) {
        const errorText = await response.text();
        let message = errorText;
        if (response.status === 409) {
          try { message = JSON.parse(errorText)?.message || "Some items are unavailable. Please update your cart."; }
          catch { message = "Some items are unavailable. Please update your cart."; }
        }
        const error = new Error(message);
        error.status = response.status;
        throw error;
    }
    const data = await response.json();
    console.log("apiPlaceOrder response", data);
    //const allInfo = localStorage.getItem('allInfo');
    // if(allInfo === undefined || allInfo === null)
    localStorage.setItem("allInfo", JSON.stringify(data));

    // console.log("allInfo place order",allInfo)
    return data;
  } catch (error) {
    console.error("Error during ordering food:", error.message);
    throw error;
  }
}

async function sendWaiterRequestAPI(params, note) {
  console.log("sendWaiterRequestAPI request", note);

  const userInfo = JSON.parse(localStorage.getItem("userInfo") || null);
  const restaurantTableId = userInfo?.tableId;
  const restaurantId = userInfo?.restaurantId;

  const dto = {
    restaurantTableId: restaurantTableId,
    notes: note,
  };
  const urlExtention = `${params}/${restaurantId}`;
  try {
    const response = await fetchAPI(urlExtention, dto, method.POST);
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`${errorText}`);
    }

    const data = await response.json();

    return data;
  } catch (error) {
    console.error("Error during waiter request:", error.message);
    throw error;
  }
}

// async function submitPayment(params, paymentDetails) {
//     console.log("payment detail request",paymentDetails)

//   try{
//      const response = await fetchAPI(params, paymentDetails, method.POST);
//      if (!response.ok) {
//       const errorText = await response.text();
//       throw new Error(`failed to submit payment details: ${errorText}`);
//     }

//     const data = await response.json();

//     return data;
//   }catch(error){ console.error("Error during submit payment details:", error.message); throw error;}
// }

async function submitPayment(param, bill, billItems, billingType) {
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  bill.restaurantOrBranchId = userInfo.restaurantId;
  console.log("update Menu Item", param, bill, billItems);

  const saveBillRequest = { bill, billItems, billingType };

  try {
    const response = await fetchAPI(param, saveBillRequest, method.POST);

    if (!response.ok) {
      const errorText = await response.text();
      alert(errorText);
      throw new Error(`Failed to save bill: ${errorText}`);
    }

    // Parse JSON response
    const data = await response.json();

    console.log("✅ Save bill successfully:");

    //localStorage.removeItem('allInfo');
    localStorage.setItem("allInfo", JSON.stringify(data));

    return await data;
  } catch (error) {
    console.error("❌ Error during save Bill Item:", error.message);
    throw error; // rethrow to handle outside if needed
  }
}

async function getMenuList(params, restoId) {
  try {
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || null);
    //const restaurantId =  userInfo !== null ? userInfo.restaurantId : restoId;
    const restaurantId = restoId || userInfo?.restaurantId;
    const urlExtention = `${params}/${restaurantId}`;
    const response = await fetchAPI(urlExtention, null, method.GET);

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`failed to fetch Menu List: ${errorText}`);
    }

    const menuList = await response.json(); // { token: "..." }

    return menuList;
  } catch (error) {
    console.error("Error during fetching Menu List:", error.message);
    throw error; // allow calling function to handle error
  }
}

async function getReorder(params, tableOtp) {
  try {
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || null);
    const restaurantId = userInfo.restaurantId; // userInfo !== null ? userInfo.restaurantId : 'FA6886A5-8CAA-4EDB-95BB-5E6EE8D95349'; //userInfo.restaurantId;
    const urlExtention = `${params}/${tableOtp}/${restaurantId}`;

    const response = await fetchAPI(urlExtention);

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`failed to fetch reorder List: ${errorText}`);
    }

    const reorderList = await response.json(); // { token: "..." }

    return reorderList;
  } catch (error) {
    console.error("Error during fetching reorder List:", error.message);
    throw error; // allow calling function to handle error
  }
}

async function getBill(params, tableOtp) {
  try {
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || null);
    const restaurantId = userInfo.restaurantId; // userInfo !== null ? userInfo.restaurantId : 'FA6886A5-8CAA-4EDB-95BB-5E6EE8D95349'; //userInfo.restaurantId;
    const urlExtention = `${params}/${tableOtp}/${restaurantId}`;
    const response = await fetchAPI(urlExtention);

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`failed to fetch bill: ${errorText}`);
    }

    const bill = await response.json(); // { token: "..." }

    return bill;
  } catch (error) {
    console.error("Error during fetching bill:", error.message);
    throw error; // allow calling function to handle error
  }
}

function logOut(params, qrScanLogId) {
  try {
    const response = fetchAPI(params, qrScanLogId, method.POST);
    sessionStorage.clear();
    localStorage.clear();
  } catch (error) {
    throw error;
  }
}

function fetchDetails(extention, params = {}) {
  const url = `${BASE_URL}/dashboard/${extention}`;
  return fetchAPI(url, params).then().catch().finally(); // todo: finish it
}

function fetchDashboard(params = {}) {
  const url = `${BASE_URL}/dashboard/`;
  return fetchAPI(url, params).then().catch().finally(); // todo: finish it
}

function hasLoggedIn() {
  if (
    localStorage.getItem("tokenExpiry") < Date.now() ||
    !localStorage.getItem("user")
  ) {
    return null;
  }
  return !localStorage.getItem(key) ? null : false;
}

async function createConnection(action) {
  const urlForSignalR = IMAGE_BASE_URL;
  const hubUrl = `${urlForSignalR}/tableHub`;
  console.log("hubUrl", hubUrl);
  const connection = new signalR.HubConnectionBuilder()
    .withUrl(hubUrl)
    .configureLogging(signalR.LogLevel.Information)
    .withAutomaticReconnect()
    .build();
  return connection;
}

export {
  fetchAPI,
  fetchDashboard,
  fetchLogin,
  fetchDetails,
  hasLoggedIn,
  logOut,
  getMenuList,
  sendOtp,
  registerUser,
  apiPlaceOrder,
  getReorder,
  getBill,
  submitPayment,
  createConnection,
  sendWaiterRequestAPI,
  fetchRestaurantLoginConfigApi,
};
